// You can specify which plugins you need
// import boostrap from 'bootstrap';
import jquery from 'jquery';
import boostrap from 'bootstrap';
